// Mangonel accepts PDF page dimensions in 72-point units, then renders the
// page in Chrome at 96 CSS pixels per inch.
export const CONTENT_CARD_PAGE_SIZE = {
    width: 612,
    height: 792
};

// The Vector Force content card uses a fixed landscape map inset within the
// portrait letter page.
export const CONTENT_CARD_MAP_SIZE = {
    width: 770,
    height: 600
};

export const zoomForViewportWidth = (zoom, previewWidth, outputWidth) => {
    if (!Number.isFinite(zoom)
        || !Number.isFinite(previewWidth)
        || !Number.isFinite(outputWidth)
        || previewWidth <= 0
        || outputWidth <= 0) {
        return zoom;
    }

    return zoom + Math.log2(outputWidth / previewWidth);
};

export const dimensionsMatch = (bounds, expectedSize) => Boolean(
    bounds
    && expectedSize
    && Math.round(bounds.width) === expectedSize.width
    && Math.round(bounds.height) === expectedSize.height
);
